import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})

export class SearchPipe implements PipeTransform {

  constructor() { }

  transform(list: any[], args = { keyword: null, term: '' }): any {

    if (args.term === '') { return list; }

    return list.filter((item: any) => {
      if (typeof item === 'string') {
        if (JSON.stringify(item).toLowerCase().includes(args.term.toLowerCase())) {
          return true;
        }
      } else if (args.keyword !== null) {
        if (JSON.stringify(item[args.keyword]).toLowerCase().includes(args.term.toLowerCase())) {
          return true;
        }
      } else {
        for (const property in item) {
          if (item[property] === null) {
            continue;
          }
          if (JSON.stringify(item[property]).toLowerCase().includes(args.term.toLowerCase())) {
            return true;
          }
        }
      }

      return false;
    });
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_pipes/search.pipe.ts